import { render, staticRenderFns } from "./numeric.vue?vue&type=template&id=499ba306&scoped=true&"
import script from "./numeric.vue?vue&type=script&lang=js&"
export * from "./numeric.vue?vue&type=script&lang=js&"
import style0 from "./numeric.vue?vue&type=style&index=0&id=499ba306&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ba306",
  null
  
)

export default component.exports